import { Auth0Context, Auth0Provider } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';

import { deferred } from 'utils/deferredToken';
// import {
//   AUTH0_DOMAIN,
//   AUTH0_CLIENT_ID,
//   AUTH0_AUDIENCE,
//   AUTH0_SCOPES,
// } from 'constants';

import { selectAppConfig } from 'store/initialize';

export const Auth0Wrapper = ({ children }) => {
  const appConfig = useSelector(selectAppConfig());
  const { auth0Domain, auth0ClientId, auth0Audience, auth0Scopes } = appConfig;
  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      audience={auth0Audience}
      redirectUri={`${window.location.origin}/homepage`}
      scope={auth0Scopes}
      useRefreshTokens={true}>
      <Auth0Context.Consumer>
        {({ getAccessTokenSilently }) => {
          deferred.resolve(getAccessTokenSilently);
          return children;
        }}
      </Auth0Context.Consumer>
    </Auth0Provider>
  );
};
